import { render, staticRenderFns } from "./CustomerSectionHeader.vue?vue&type=template&id=ca00c7de&scoped=true"
import script from "./CustomerSectionHeader.vue?vue&type=script&lang=js"
export * from "./CustomerSectionHeader.vue?vue&type=script&lang=js"
import "./CustomerSectionHeader.vue?vue&type=style&index=0&id=ca00c7de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca00c7de",
  null
  
)

export default component.exports